import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { authReducer } from './reducers/AuthReducer';
import { categoryReducer } from './reducers/CategoryReducer';
import thunk from 'redux-thunk';
import { pageReducer } from './reducers/PageReducer';
import { ruleReducer } from './reducers/RuleReducer';
import { componentReducer } from './reducers/ComponentReducer';
import { listReducer } from './reducers/ListReducer';
import { basicReducer } from './reducers/BasicReducer';
import { queryReducer } from './reducers/QueryReducer';
import { listVariableReducer } from './reducers/ListVariableReducer';
import { apiVariableReducer } from './reducers/ApiVariableReducer';
import { connectionReducer } from './reducers/ConnectionReducer';
import { structReducer } from './reducers/StructReducer';
import { transactionReducer } from './reducers/TransactionReducer';
import { velocityVariableReducer } from './reducers/VelocityVariableReducer';
import { streamReducer } from './reducers/StreamReducer';
import { configurationReducer } from './reducers/ConfigurationReducer';
import { importReasonReducer } from './reducers/ImportReasonReducer';
import { actionReducer } from './reducers/ActionReducer';
import { caseReducer } from './reducers/CaseReducer';
import { watchlistReducer } from './reducers/WatchlistReducer';
import { graphReducer } from './reducers/GraphReducer';
import { chartReducer } from './reducers/ChartReducer';
import { dashboardReducer } from './reducers/DashboardReducer';
import { aiModelReducer } from './reducers/AiModelReducer';
import { trackerReducer } from './reducers/TrackerReducer';
import { sandboxReducer } from './reducers/SandboxReducer';
import { policyReducer } from './reducers/PolicyReducer';
import { craApiVariableReducer } from './reducers/CraPolicyVariableReducer';
import { bulkActionReducer } from './reducers/BulkActionReducer';

declare global {
  interface Window {
    _REDUX_DEVTOOLS_EXTENSION_COMPOSE_?: typeof compose;
  }
}

const composeEnhancers = window._REDUX_DEVTOOLS_EXTENSION_COMPOSE_ || compose;

const reducers = combineReducers({
  auth: authReducer,
  category: categoryReducer,
  page: pageReducer,
  event: transactionReducer,
  rule: ruleReducer,
  component: componentReducer,
  list: listReducer,
  basic: basicReducer,
  query: queryReducer,
  listVariable: listVariableReducer,
  apiVariable: apiVariableReducer,
  connection: connectionReducer,
  struct: structReducer,
  velocityVariable: velocityVariableReducer,
  stream: streamReducer,
  configuration: configurationReducer,
  importReason: importReasonReducer,
  action: actionReducer,
  case: caseReducer,
  watchlist: watchlistReducer,
  graph: graphReducer,
  chart: chartReducer,
  dashboard: dashboardReducer,
  aiModel: aiModelReducer,
  tracker: trackerReducer,
  sandbox: sandboxReducer,
  policy: policyReducer,
  craApiVariable: craApiVariableReducer,
  bulkAction: bulkActionReducer,
});

export const store = createStore(reducers, {}, composeEnhancers(applyMiddleware(thunk)));

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
export const dispatch = store.dispatch;
